import {
  MockMap,
  utils,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  acknowledgeSuccess,
} from '../../../mock/data/index';

const getAlternativeOffersMockDisruptedMultiBounds = {
  data: [
    {
      type: 'alternative-offers',
      id: '1Ba8KkrOdbU',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 6300,
          flights: [
            {
              id: 'FLT1'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bb8Kkr4H5y',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 10_500,
          flights: [
            {
              id: 'FLT2'
            },
            {
              id: 'FLT3'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bc8Kkrj18R',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 11_100,
          flights: [
            {
              id: 'FLT2'
            },
            {
              id: 'FLT4'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bd8KkrtHDk',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 12_900,
          flights: [
            {
              id: 'FLT5'
            },
            {
              id: 'FLT6'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Be8Kkr5RYu',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT7'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bf8Kkrymuy',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT8'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bg8Kkr-sYy',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT9'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bh8KkrNwAm',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2400,
          flights: [
            {
              id: 'FLT10'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bi8Kkr0P_f',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT11'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bj8Kkrx1DP',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 12_000,
          flights: [
            {
              id: 'FLT12'
            },
            {
              id: 'FLT13'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bk8KkrES4p',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT14'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bl8KkrMJfy',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT15'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bm8KkrJdGa',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT16'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bn8KkrWEs',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 10_500,
          flights: [
            {
              id: 'FLT17'
            },
            {
              id: 'FLT18'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bo8KkrVca9',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT19'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bp8KkrgpRl',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT20'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bq8KkrkNEL',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2400,
          flights: [
            {
              id: 'FLT21'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Br8KkrFHTz',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 6300,
          flights: [
            {
              id: 'FLT22'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bs8KkrLgGF',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 10_500,
          flights: [
            {
              id: 'FLT23'
            },
            {
              id: 'FLT24'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bt8KkrC0ql',
      expiryDateTime: new utils.DateTime('2030-04-30T09:30:43Z'),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 11_100,
          flights: [
            {
              id: 'FLT23'
            },
            {
              id: 'FLT25'
            }
          ]
        }
      }
    }
  ],
  dictionaries: {
    airline: {
      AY: 'FINNAIR',
      SK: 'SCANDINAVIAN AIRLINES',
      W2: 'FLEXFLIGHT'
    },
    location: {
      ARN: {
        type: 'airport',
        airportName: 'ARLANDA',
        cityCode: 'STO',
        countryCode: 'SE'
      },
      HEL: {
        type: 'airport',
        airportName: 'HELSINKI VANTAA',
        cityCode: 'HEL',
        cityName: 'HELSINKI',
        countryCode: 'FI'
      },
      MHQ: {
        type: 'airport',
        airportName: 'MARIEHAMN',
        cityCode: 'MHQ',
        cityName: 'MARIEHAMN',
        countryCode: 'FI'
      },
      TKU: {
        type: 'airport',
        airportName: 'TURKU',
        cityCode: 'TKU',
        cityName: 'TURKU',
        countryCode: 'FI'
      },
      STO: {
        type: 'city',
        cityCode: 'STO',
        cityName: 'STOCKHOLM',
        countryCode: 'SE'
      }
    },
    flight: {
      FLT3: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime('2030-04-15T17:10:43Z'),
          terminal: '5'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'SK',
        marketingAirlineCode: 'SK',
        marketingFlightNumber: '4236',
        duration: 3300,
        aircraftCode: 'AT7'
      },
      FLT8: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '225',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT19: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '225',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT9: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '633',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT6: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '5'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'SK',
        marketingAirlineCode: 'SK',
        marketingFlightNumber: '2728',
        duration: 3300,
        aircraftCode: 'AT7'
      },
      FLT2: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '2'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '813',
        duration: 3600,
        aircraftCode: '320'
      },
      FLT4: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-15T19:05:43Z'),
          terminal: '0'
        },
        operatingAirlineCode: 'W2',
        marketingAirlineCode: 'W2',
        marketingFlightNumber: '2104',
        duration: 3300,
        aircraftCode: 'SF3'
      },
      FLT13: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime('2030-04-17T15:30:43Z'),
          terminal: '5'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-17T17:25:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'SK',
        marketingAirlineCode: 'SK',
        marketingFlightNumber: '4234',
        duration: 3300,
        aircraftCode: 'AT7'
      },
      FLT20: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-16T20:00:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-16T20:35:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '633',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT7: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-15T13:55:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-15T14:30:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '223',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT5: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-15T12:20:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime('2030-04-15T12:20:43Z'),
          terminal: '2'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '807',
        duration: 3600,
        aircraftCode: '319'
      },
      FLT17: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-16T16:10:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime('2030-04-16T16:10:43Z'),
          terminal: '2'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '813',
        duration: 3600,
        aircraftCode: '320'
      },
      FLT22: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-19T08:10:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-19T09:55:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '649',
        duration: 6300,
        aircraftCode: 'AT7',
        stops: [
          {
            locationCode: 'MHQ',
            duration: 1200,
            isChangeOfGauge: false,
            arrivalDateTime: new utils.DateTime('2030-04-14T09:05:43Z'),
            departureDateTime: new utils.DateTime('2030-04-14T09:25:43Z'),
            aircraftCode: 'AT7'
          }
        ]
      },
      FLT1: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-15T08:10:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-15T09:55:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '649',
        duration: 6300,
        aircraftCode: 'AT7',
        stops: [
          {
            locationCode: 'MHQ',
            duration: 1200,
            isChangeOfGauge: false,
            arrivalDateTime: new utils.DateTime('2030-04-15T09:05:43Z'),
            departureDateTime: new utils.DateTime('2030-04-15T09:25:43Z'),
            aircraftCode: 'AT7'
          }
        ]
      },
      FLT21: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-18T23:45:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-19T00:25:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '229',
        duration: 2400,
        aircraftCode: 'AT7'
      },
      FLT18: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime('2030-04-16T17:10:43Z'),
          terminal: '5'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-16T19:05:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'SK',
        marketingAirlineCode: 'SK',
        marketingFlightNumber: '4236',
        duration: 3300,
        aircraftCode: 'AT7'
      },
      FLT14: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-17T13:55:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-17T14:30:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '223',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT16: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-17T20:00:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-17T20:35:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '633',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT10: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-15T23:45:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-16T00:25:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '229',
        duration: 2400,
        aircraftCode: 'AT7'
      },
      FLT25: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime('2030-04-19T17:20:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-19T19:15:43Z'),
          terminal: '0'
        },
        operatingAirlineCode: 'W2',
        marketingAirlineCode: 'W2',
        marketingFlightNumber: '2104',
        duration: 3300,
        aircraftCode: 'SF3'
      },
      FLT12: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-17T14:05:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime('2030-04-17T14:00:43Z'),
          terminal: '2'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '809',
        duration: 3300,
        aircraftCode: '32B'
      },
      FLT23: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-19T16:10:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime('2030-04-19T16:10:43Z'),
          terminal: '2'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '813',
        duration: 3600,
        aircraftCode: '320'
      },
      FLT24: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime('2030-04-19T17:10:43Z'),
          terminal: '5'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-19T19:05:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'SK',
        marketingAirlineCode: 'SK',
        marketingFlightNumber: '4236',
        duration: 3300,
        aircraftCode: 'AT7'
      },
      FLT15: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-17T16:15:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-17T16:50:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '225',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT11: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-16T13:55:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-16T14:30:43Z'),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '223',
        duration: 2100,
        aircraftCode: 'AT7'
      }
    },
    aircraft: {
      319: 'AIRBUS INDUSTRIE A319',
      320: 'AIRBUS INDUSTRIE A320-100/200',
      '32B': 'AIRBUS INDUSTRIE A321 SHARKLETS',
      AT7: 'AEROSPATIALE/ALENIA ATR 72',
      SF3: 'SAAB SF340A/340B'
    }
  }
};

const retrieveOrderMockDisruptedMultiBounds = {
  warnings: [
    {
      code: '65227',
      title: 'FLIGHT DISRUPTION HAS OCCURRED: CHECK THE ORDER CONTENT'
    }
  ],
  data: {
    id: 'TC59QW',
    creationPointOfSale: {
      pointOfSaleId: 'HELAY08MO',
      countryCode: 'FI'
    },
    creationDateTime: new utils.DateTime('2030-04-15T10:00:43Z'),
    lastModificationDateTime: new utils.DateTime('2030-04-15T10:00:43Z'),
    isGroupBooking: false,
    air: {
      bounds: [
        {
          airBoundId: '15d58dd5ce4',
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          flights: [
            {
              id: 'ST3',
              cabin: 'eco',
              bookingClass: 'Y',
              statusCode: 'TK'
            }
          ],
          duration: 2100,
          disruptionStatus: {
            boundStatus: 'disrupted',
            originalFlights: [
              {
                id: 'ST1',
                cabin: 'eco',
                bookingClass: 'Y',
                statusCode: 'UN'
              }
            ],
            departure: {
              locationCode: 'HEL',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 8400
            },
            arrival: {
              locationCode: 'TKU',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 8400
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 0
            },
            duration: 2100
          }
        },
        {
          airBoundId: '1d59d355c8c',
          originLocationCode: 'TKU',
          destinationLocationCode: 'HEL',
          flights: [
            {
              id: 'ST4',
              cabin: 'eco',
              bookingClass: 'Y',
              statusCode: 'TK'
            }
          ],
          duration: 2100,
          disruptionStatus: {
            boundStatus: 'disrupted',
            originalFlights: [
              {
                id: 'ST2',
                cabin: 'eco',
                bookingClass: 'Y',
                statusCode: 'UN'
              }
            ],
            departure: {
              locationCode: 'TKU',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 39_300
            },
            arrival: {
              locationCode: 'HEL',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 39_300
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 0
            },
            duration: 2100
          }
        }
      ]
    },
    services: [
      {
        id: 'TSM30',
        descriptions: [
          {
            type: 'shortText',
            content: 'WEAP'
          },
          {
            type: 'longText',
            content: 'WEAPON HANDLING FEE'
          }
        ],
        quantity: 2,
        flightIds: ['ST3', 'ST4'],
        details: [
          {
            flightId: 'ST3',
            quantity: 1
          },
          {
            flightId: 'ST4',
            quantity: 1
          }
        ]
      },
      {
        id: 'OT49',
        descriptions: [
          {
            type: 'shortText',
            content: 'COLA'
          }
        ],
        quantity: 1,
        flightIds: ['ST3']
      },
      {
        id: 'OT50',
        descriptions: [
          {
            type: 'shortText',
            content: 'COLA'
          }
        ],
        quantity: 1,
        flightIds: ['ST4']
      },
      {
        id: 'TSM51',
        descriptions: [
          {
            type: 'shortText',
            content: 'TRML'
          }
        ],
        quantity: 1,
        flightIds: ['ST3']
      },
      {
        id: 'OT51',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          }
        ],
        quantity: 1,
        flightIds: ['ST3']
      }
    ],
    seats: [
      {
        id: 'seat1',
        flightId: 'ST3',
        seatSelections: [
          {
            seatCharacteristics: [
              {
                code: 'CH'
              }
            ]
          }
        ]
      },
      {
        id: 'seat2',
        flightId: 'ST4',
        seatSelections: [
          {
            seatCharacteristics: [
              {
                code: 'E'
              }
            ]
          }
        ]
      }
    ],
    travelers: [
      {
        id: 'PT1',
        names: [
          {
            firstName: 'Tony',
            lastName: 'Perry',
            nameType: 'universal'
          }
        ]
      },
      {
        passengerTypeCode: 'CHD',
        id: 'PT2',
        names: [
          {
            firstName: 'Bobby',
            lastName: 'Perry',
            nameType: 'universal'
          }
        ],
        dateOfBirth: '2016-04-05'
      }
    ],
    contacts: [
      {
        id: 'OT6',
        category: 'other',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        countryPhoneExtension: '+91',
        number: '7418529630'
      }
    ],
    travelDocuments: [
      {
        flightIds: ['ST3', 'ST4'],
        travelerIds: ['PT1'],
        id: '1052467303584',
        documentType: 'eticket',
        price: {
          base: 48_400,
          total: 65_948,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 8600,
              currencyCode: 'EUR',
              code: 'YR'
            },
            {
              value: 976,
              currencyCode: 'EUR',
              code: 'DQ'
            },
            {
              value: 1776,
              currencyCode: 'EUR',
              code: 'QU'
            },
            {
              value: 200,
              currencyCode: 'EUR',
              code: 'XU'
            },
            {
              value: 5996,
              currencyCode: 'EUR',
              code: 'YF'
            }
          ],
          totalTaxes: 17_548
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'YPR0FI',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '225',
              departure: {
                locationCode: 'HEL',
                dateTime: new utils.DateTime('2030-04-16T16:15:43Z')
              },
              arrival: {
                locationCode: 'TKU'
              }
            }
          },
          {
            fareClass: 'YPR0FI',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '226',
              departure: {
                locationCode: 'TKU',
                dateTime: new utils.DateTime('2030-04-21T17:10:43Z')
              },
              arrival: {
                locationCode: 'HEL'
              }
            }
          }
        ]
      },
      {
        flightIds: ['ST3', 'ST4'],
        travelerIds: ['PT2'],
        id: '1052467303583',
        documentType: 'eticket',
        price: {
          base: 36_300,
          total: 52_638,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 8600,
              currencyCode: 'EUR',
              code: 'YR'
            },
            {
              value: 976,
              currencyCode: 'EUR',
              code: 'DQ'
            },
            {
              value: 1776,
              currencyCode: 'EUR',
              code: 'QU'
            },
            {
              value: 200,
              currencyCode: 'EUR',
              code: 'XU'
            },
            {
              value: 4786,
              currencyCode: 'EUR',
              code: 'YF'
            }
          ],
          totalTaxes: 16_338
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'YPR0FI/CH',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '225',
              departure: {
                locationCode: 'HEL',
                dateTime: new utils.DateTime('2030-04-16T16:15:43Z')
              },
              arrival: {
                locationCode: 'TKU'
              }
            }
          },
          {
            fareClass: 'YPR0FI/CH',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '226',
              departure: {
                locationCode: 'TKU',
                dateTime: new utils.DateTime('2030-04-21T17:10:43Z')
              },
              arrival: {
                locationCode: 'HEL'
              }
            }
          }
        ]
      }
    ],
    specialServiceRequests: [
      {
        id: 'OT3',
        code: 'CHLD',
        airlineCode: 'AY',
        statusCode: 'HK',
        quantity: 1,
        freetext: '05APR16',
        travelerIds: ['PT2']
      }
    ],
    orderEligibilities: {
      change: [
        {
          flightIds: ['ST1'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: ['ST3'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: ['ST2'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: ['ST4'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        }
      ],
      cancel: {
        isEligible: false
      },
      flightReaccommodation: {
        acknowledge: [
          {
            airBoundId: '15d58dd5ce4',
            isEligible: true,
            nonEligibilityReason: 'notActivated'
          },
          {
            airBoundId: '1d59d355c8c',
            isEligible: false,
            nonEligibilityReason: 'notActivated'
          }
        ],
        change: [
          {
            airBoundId: '15d58dd5ce4',
            isEligible: true
          },
          {
            airBoundId: '1d59d355c8c',
            isEligible: true
          }
        ]
      }
    }
  },
  dictionaries: {
    location: {
      HEL: {
        type: 'airport',
        airportName: 'HELSINKI VANTAA',
        cityCode: 'HEL',
        cityName: 'HELSINKI',
        countryCode: 'FI',
        timeZone: 'UTC+0200'
      },
      TKU: {
        type: 'airport',
        airportName: 'TURKU',
        cityCode: 'TKU',
        cityName: 'TURKU',
        countryCode: 'FI',
        timeZone: 'UTC+0200'
      }
    },
    country: {
      FI: 'FINLAND'
    },
    airline: {
      AY: 'FINNAIR'
    },
    aircraft: {
      AT7: 'AEROSPATIALE/ALENIA ATR 72'
    },
    flight: {
      ST2: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '230',
        departure: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-21T06:15:43Z'),
          terminal: '1'
        },
        arrival: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-21T06:50:43Z'),
          terminal: '2'
        },
        aircraftCode: 'AT7',
        duration: 2100,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      },
      ST1: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '223',
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-16T13:55:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-16T14:30:43Z'),
          terminal: '1'
        },
        aircraftCode: 'AT7',
        duration: 2100,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      },
      ST4: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '226',
        departure: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-21T17:10:43Z'),
          terminal: '1'
        },
        arrival: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-21T17:45:43Z'),
          terminal: '2'
        },
        aircraftCode: 'AT7',
        duration: 2100,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      },
      ST3: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '225',
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime('2030-04-16T16:15:43Z'),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime('2030-04-16T16:50:43Z'),
          terminal: '1'
        },
        aircraftCode: 'AT7',
        duration: 2100,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      }
    },
    tax: {
      QU: 'QU',
      YR: 'YR',
      DQ: 'DQ',
      XU: 'XU',
      YF: 'YF'
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    specialServiceRequest: {
      CHLD: {
        name: 'CHILD PASSENGER INFORMATION'
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      },
      TK: {
        name: 'Confirmed, timechange'
      },
      UN: {
        name: 'Unable, does not operate'
      }
    },
    meal: {
      N: 'NO MEAL SERVICE'
    }
  }
};

export const disruptedMultiBoundsFixedDateMock: MockMap = {
  retrieveOrder: [
    {
      mockData: retrieveOrderMockDisruptedMultiBounds
    }
  ],
  getOrderEligibilities: [],
  getAlternativeOffers: [
    {
      mockData: getAlternativeOffersMockDisruptedMultiBounds
    }
  ],
  acknowledge: [createMockData(acknowledgeSuccess)]
};
